export const TelegramSecond = ({
  width = '25',
  height = '25',
  fill = '#23A6CF',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.560791 12.2804C0.560791 19.0626 6.0589 24.5607 12.8412 24.5607C19.6234 24.5607 25.1215 19.0626 25.1215 12.2804C25.1215 5.49811 19.6234 0 12.8412 0C6.0589 0 0.560791 5.49811 0.560791 12.2804ZM10.5898 17.9088L10.7987 14.7785L10.7985 14.7784L16.493 9.63955C16.7429 9.41774 16.4384 9.30958 16.1067 9.51077L9.07891 13.9445L6.0433 12.997C5.38774 12.7963 5.38303 12.3458 6.19048 12.022L18.0196 7.46073C18.5598 7.21545 19.0813 7.59049 18.875 8.41739L16.8605 17.9104C16.7199 18.585 16.3123 18.7464 15.7475 18.4348L12.6788 16.1675L11.2038 17.6018C11.1991 17.6064 11.1945 17.6109 11.1899 17.6153C11.0249 17.776 10.8884 17.9088 10.5898 17.9088Z"
        fill={fill}
      />
    </svg>
  );
};
